/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.defs'

type $nsid = typeof $nsid

export { $nsid }

type JobStatus = {
  $type?: 'app.bsky.video.defs#jobStatus'
  did: l.DidString
  blob?: l.BlobRef
  error?: string
  jobId: string

  /**
   * The state of the video processing job. All values not listed as a known value indicate that the job is in process.
   */
  state:
    | 'JOB_STATE_CREATED'
    | 'JOB_STATE_ENCODING'
    | 'JOB_STATE_ENCODED'
    | 'JOB_STATE_SCANNING'
    | 'JOB_STATE_SCANNED'
    | 'JOB_STATE_UPLOADING'
    | 'JOB_STATE_UPLOADED'
    | 'JOB_STATE_COMPLETED'
    | 'JOB_STATE_FAILED'
    | l.UnknownString
  message?: string

  /**
   * Progress within the current processing state.
   */
  progress?: number

  /**
   * A machine-readable code for why the video processing job failed.
   */
  failureCode?:
    | 'validation_failure'
    | 'encoding_failure'
    | 'pds_upload_failure'
    | 'pds_upload_unsupported_blob_size'
    | 'generic_failure'
    | l.UnknownString
}

export type { JobStatus }

const jobStatus = /*#__PURE__*/ l.typedObject<JobStatus>(
  $nsid,
  'jobStatus',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    blob: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob()),
    error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    jobId: /*#__PURE__*/ l.string(),
    state: /*#__PURE__*/ l.string<{
      knownValues: [
        'JOB_STATE_CREATED',
        'JOB_STATE_ENCODING',
        'JOB_STATE_ENCODED',
        'JOB_STATE_SCANNING',
        'JOB_STATE_SCANNED',
        'JOB_STATE_UPLOADING',
        'JOB_STATE_UPLOADED',
        'JOB_STATE_COMPLETED',
        'JOB_STATE_FAILED',
      ]
    }>(),
    message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    progress: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 0 }),
    ),
    failureCode: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'validation_failure',
          'encoding_failure',
          'pds_upload_failure',
          'pds_upload_unsupported_blob_size',
          'generic_failure',
        ]
      }>(),
    ),
  }),
)

export { jobStatus }
